import React from 'react';
import './NavigationControls.css';

const NavigationControls = ({ canGoBack, onGoBack }) => {
  if (!canGoBack) return null;

  return (
    <div className="navigation-controls">
      <button 
        className="back-button"
        onClick={onGoBack}
        title="View previous bubble"
        aria-label="View previous bubble"
      >
        <div className="back-arrow">←</div>
        <span className="back-label">Previous</span>
      </button>
    </div>
  );
};

export default NavigationControls;
